import clsx from 'clsx';
import { useScreenType } from '@web3/base-hooks';

export default function Block(props: {
  className?: string;
  title?: string;
  titleClass?: string;
  titleButton?: React.ReactNode;
  children?: React.ReactNode;
}) {
  const { isMobile } = useScreenType();
  const { className, title, titleClass = '', titleButton } = props;
  return (
    <section
      className={clsx(`section-block main ${className}`, isMobile && 'px-4')}
    >
      {title && (
        <h1
          className={clsx(
            'font-semibold flex items-center justify-between',
            isMobile ? 'text-2xl mb-8' : 'mb-6 text-4hxl ',
            titleClass
          )}
        >
          {title}
          {titleButton}
        </h1>
      )}
      {props.children}
    </section>
  );
}
